export function getZodiacSign(
  dateString: string,
  t: (key: string, fallback?: string) => string,
): string {
  if (!dateString) return "";
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateString);
  if (!match) return "";

  const month = parseInt(match[2], 10);
  const day = parseInt(match[3], 10);
  if (Number.isNaN(month) || Number.isNaN(day)) return "";

  let zodiacKey = "";
  if ((month === 3 && day >= 21) || (month === 4 && day <= 19)) zodiacKey = "aries";
  else if ((month === 4 && day >= 20) || (month === 5 && day <= 20))
    zodiacKey = "taurus";
  else if ((month === 5 && day >= 21) || (month === 6 && day <= 20))
    zodiacKey = "gemini";
  else if ((month === 6 && day >= 21) || (month === 7 && day <= 22))
    zodiacKey = "cancer";
  else if ((month === 7 && day >= 23) || (month === 8 && day <= 22))
    zodiacKey = "leo";
  else if ((month === 8 && day >= 23) || (month === 9 && day <= 22))
    zodiacKey = "virgo";
  else if ((month === 9 && day >= 23) || (month === 10 && day <= 22))
    zodiacKey = "libra";
  else if ((month === 10 && day >= 23) || (month === 11 && day <= 21))
    zodiacKey = "scorpio";
  else if ((month === 11 && day >= 22) || (month === 12 && day <= 21))
    zodiacKey = "sagittarius";
  else if ((month === 12 && day >= 22) || (month === 1 && day <= 19))
    zodiacKey = "capricorn";
  else if ((month === 1 && day >= 20) || (month === 2 && day <= 18))
    zodiacKey = "aquarius";
  else if ((month === 2 && day >= 19) || (month === 3 && day <= 20))
    zodiacKey = "pisces";

  if (zodiacKey) return t(`zodiac.${zodiacKey}`, zodiacKey);
  return "";
}
